import { useMemo } from 'react'
import queryString from 'query-string'
import { useLocation, useParams } from 'react-router-dom'

export const useSearchParams = () => {
  const params = useParams()
  const location = useLocation()

  const { category, profile: routeProfile } = params
  const { q: queryQ } = useMemo(
    () => queryString.parse(location.search),
    [location.search]
  )

  return { category, routeProfile, queryQ }
}

export default useSearchParams
